import type { LayoutProps } from '../../../../types';
import Box from '@mui/material/Box';

interface Props {
  hidden: LayoutProps['hidden'];
  settings: LayoutProps['settings'];
  saveSettings: LayoutProps['saveSettings'];
  appBarContent: NonNullable<
    NonNullable<LayoutProps['horizontalLayoutProps']>['appBar']
  >['content'];
  appBarBranding: NonNullable<
    NonNullable<LayoutProps['horizontalLayoutProps']>['appBar']
  >['branding'];
  appBarNav: NonNullable<NonNullable<LayoutProps['horizontalLayoutProps']>['appBar']>['nav'];
}

const AppBarContent = (props: Props) => {
  // ** Props
  const {
    appBarContent: userAppBarContent,
    appBarBranding: userAppBarBranding,
    appBarNav: userAppBarNav,
  } = props;

  // ** Hooks

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {userAppBarBranding ? userAppBarBranding(props) : null}
      {userAppBarNav ? userAppBarNav(props) : null}
      {userAppBarContent ? userAppBarContent(props) : null}
    </Box>
  );
};

export default AppBarContent;
